/* eslint-disable max-statements */
/* eslint-disable complexity */
import { carConsumerService } from "../../../service/car-consumer-gateway-api";
import { LeadServiceJava } from "../../../service/lead-service-java-api";
import {
    getPaiState,
    isAuctionOver,
    parseChallanDetails,
    isDoctetAllowed,
    getUpdatedPriceDiscovery,
    isAuctionRunning
} from "../post-inspection-diy/selector";
import { AUCTION_TYPE, GS_AUCTION, LEADMON_TRANSACTION_STATUS, SCREEN_TYPES, VIDEO_SLUGS, OFFLINE_FLOW_STATUS, OFFLINE_FLOW_STATES } from "../post-inspection-diy/constant";
import isObjectEmpty from "../../../utils/helpers/isObjectEmpty";
import {getCurrentTab, getParsedPriceBreakup} from "./selector";
import { getDeviceType } from "../../../utils/helpers/device-type";
import { VehicleService } from "../../../service/vehicle-service";
import { NUMBER } from "../../../constants/app-constants";
import parseSellerPackageDetails from "../../../utils/parsers/parse-seller-package-details";
import { SuperAppCmsService } from "../../../service/super-app-cms-service";

const getPriceBreakup = (token) => {
    return new Promise((resolve, reject) => {
        carConsumerService.priceBreakup(token)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const getChallanDetails = (appointmentId) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getChallanDetails(appointmentId)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const getPickupDoctetDetails = (token) => {
    return new Promise((resolve, reject) => {
        carConsumerService.pickupDocument(token).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const getPickupDetails = (token) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getPickupDetail(token).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const getRepeatInspectionDetails = (data) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getRepeatInspectionDetails(data)
            .then((response) => {
                resolve(response.data.detail);
            }).catch((error) => {
                reject(error);
            });
    });
};

const getSelfNegoOptimalPrice = (token) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getSelfNegoOptimalPrice(token).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const getDirectOcbOptimalPrice = (token) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getDirectOcbOptimalPrice(token).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const getGSOcbOptimalPrice = (token) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getGSOcbOptimalPrice(token).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const getSelfNegoKycDetails = (token) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getSelfNegoKycDetails(token).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const fetchVideoGallery = (slug = "") => {
    return new Promise((resolve, reject) => {
        VehicleService.fetchVideoGallery(slug)
            .then((response) => resolve(response.data.detail))
            .catch(error => reject(error));
    });
};

const getSimilarCarCount = (token) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getSimilarCarCount(token)
            .then((response) => resolve(response.data))
            .catch(error => reject(error));
    });
};

const getImpressionsCount = (token) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getImpressionsCount(token)
            .then((response) => resolve(response.data))
            .catch(error => reject(error));
    });
};

const getLeadMonDetails = (token) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getLeadMonDetails(token)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const getFranchiseDetails = (apptId) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getFranchiseDetails(apptId)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};
const getCarHealth = (token, sellerPackageEligibility) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getCarHealth(token)
            .then((response) => {
                resolve(parseSellerPackageDetails(response.data, sellerPackageEligibility));
            }).catch(error => {
                reject(error);
            });
    });
};

const getOfflineTxnDetials = (token) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getOfflineTxnDetials(token)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

// eslint-disable-next-line no-unused-vars
const getOrderDetails = (details) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.getOrderDetails(details)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const fetchSellerPackageData = (payload) => () => {
    return new Promise((resolve, reject) => {
        SuperAppCmsService.getCmsData(payload)
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

// eslint-disable-next-line no-unused-vars
const getCombinedDiyDetails = (inspectionResponse, showLoaderScreen) => dispatch => {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                appointmentId,
                token: inspectionToken,
                leadToken,
                showServiceCharge = true,
                allowPllIntent = false,
                pll,
                screen = "",
                auction,
                pickupStatus,
                priceDiscovery,
                priceDo: auctionResponse,
                isDeliveryApproved,
                screenData,
                purchaseRequestStatus,
                leadMonStatus,
                leadMon,
                featureData = {},
                flowData = {},
                sellerPackageEligibility
            } = inspectionResponse;

            const { selfBoughtEnabled = false, dnpPriceConfirmationEnabled = false } = featureData || {};
            const { selectedFlow, applicableFlows } = flowData || {};
            let offlineDetails = {};
            if (selectedFlow && [OFFLINE_FLOW_STATES.OFFLINE, OFFLINE_FLOW_STATES.CARS24].includes(selectedFlow) && applicableFlows.includes(OFFLINE_FLOW_STATES.OFFLINE)) {
                offlineDetails = await getOfflineTxnDetials(inspectionToken);
                const { status = "" } = offlineDetails || {};
                if (status && [OFFLINE_FLOW_STATUS.PENDING || OFFLINE_FLOW_STATUS.BOUGHT].includes(status)) {
                    const carHealth = await getCarHealth(inspectionToken, sellerPackageEligibility);
                    resolve({
                        inspectionResponse: {
                            ...inspectionResponse,
                            defaultTab: NUMBER.ONE
                        },
                        carHealth,
                        offlineDetails
                    });
                }
            }
            let franchiseDetails = {};
            if (selfBoughtEnabled) franchiseDetails = await getFranchiseDetails(appointmentId);
            const {status = "", isVerified = false} = franchiseDetails || {};
            if (selfBoughtEnabled && !!status) {
                const defaultTab = getCurrentTab({ status, isVerified });
                const carHealth = await getCarHealth(inspectionToken, sellerPackageEligibility);
                resolve({
                    inspectionResponse: {
                        ...inspectionResponse,
                        defaultTab
                    },
                    franchiseDetails,
                    carHealth,
                    showSelfBought: selfBoughtEnabled
                });
                return;
            }

            const { variant: selfNegoVariant = "" } = screenData || {};
            const { customerOcb, auctionType, assuredPriceFlag = false, customerAuctionCount } = auction || {};
            const isSelfNegotiation = screen === SCREEN_TYPES.SELF_NEGOTIATION;
            const isResetAuction = screen === SCREEN_TYPES.REPEAT_USER;
            const challanDataPromise = getChallanDetails(appointmentId);
            const isDirectOcb = isSelfNegotiation && selfNegoVariant === SCREEN_TYPES.DIRECT_OCB;
            const isGSOCB = isSelfNegotiation && selfNegoVariant === SCREEN_TYPES.GS_OCB;

            const { captureIntentAgain = false, intent = "" } = pll || {};
            const { offeredPrice, isExpired, customerExpectedPrice } = auctionResponse || {};
            const isNoBid =  !offeredPrice || offeredPrice === 0 || isExpired;
            const isCampaignEnabled = (isExpired || !offeredPrice) && (allowPllIntent || captureIntentAgain);
            const askUserIntent = isAuctionOver(priceDiscovery) && (isExpired || !offeredPrice) && ((allowPllIntent && !intent) || captureIntentAgain);
            const isRepeatUser = isResetAuction || isSelfNegotiation;

            let doctetPromise = Promise.resolve({});
            let pickupDetailPromise = Promise.resolve({});
            let paiState = "";
            let repeatUserDetailsPromise = Promise.resolve({});
            let selfNegoDetailsPromise = Promise.resolve({});
            let priceBreakupPromise = Promise.resolve({});
            let selfNegoKycDetailsPromise = Promise.resolve({});
            let helperVideosPromise = Promise.resolve([]);
            let selfNegoVideoPromise = Promise.resolve([]);
            let leadMonDetailsPromise = Promise.resolve([]);
            let similarCarSoldPromise = Promise.resolve([]);
            let impressionCountPromise = Promise.resolve([]);
            const carHealthPromise = getCarHealth(inspectionToken, sellerPackageEligibility);

            if (!!offeredPrice && !isDeliveryApproved && (!isSelfNegotiation || (isSelfNegotiation && dnpPriceConfirmationEnabled))) {
                priceBreakupPromise = getPriceBreakup(inspectionToken);
            }

            if (selectedFlow === OFFLINE_FLOW_STATES.OFFLINE) {
                selfNegoDetailsPromise = getDirectOcbOptimalPrice(inspectionToken).catch(() => ({}));
            }

            if (isDirectOcb) {
                selfNegoDetailsPromise = getDirectOcbOptimalPrice(inspectionToken).catch(() => ({}));
                selfNegoKycDetailsPromise = getSelfNegoKycDetails(inspectionToken).catch(() => ({}));
                selfNegoVideoPromise = fetchVideoGallery(VIDEO_SLUGS.DIRECT_OCB);
            }

            if (isGSOCB) {
                selfNegoDetailsPromise = getGSOcbOptimalPrice(inspectionToken).catch(() => ({}));
                selfNegoKycDetailsPromise = getSelfNegoKycDetails(inspectionToken).catch(() => ({}));
                selfNegoVideoPromise = fetchVideoGallery(VIDEO_SLUGS.DIRECT_OCB);
            }

            if (isSelfNegotiation && !isDirectOcb && !isGSOCB) {
                selfNegoDetailsPromise = getSelfNegoOptimalPrice(inspectionToken).catch(() => ({}));
                selfNegoKycDetailsPromise = getSelfNegoKycDetails(inspectionToken).catch(() => ({}));
                selfNegoVideoPromise = fetchVideoGallery(VIDEO_SLUGS.SELF_NEGO);
            }

            if ((isExpired || !offeredPrice) && askUserIntent && !isSelfNegotiation) {
                repeatUserDetailsPromise = getRepeatInspectionDetails(leadToken);
            }

            if (isAuctionOver(priceDiscovery) && !isSelfNegotiation && !isRepeatUser) {
                paiState = getPaiState({ offeredPrice, customerExpectedPrice });
            }

            pickupDetailPromise = getPickupDetails(inspectionToken);

            if (isDoctetAllowed(pickupStatus) && !isCampaignEnabled && !isRepeatUser) {
                doctetPromise = getPickupDoctetDetails(inspectionToken);
            }

            if (isAuctionOver(priceDiscovery) && !isDeliveryApproved) {
                helperVideosPromise = fetchVideoGallery(VIDEO_SLUGS.POST_INSPECTION_DIY);
            }

            if (leadMon &&  leadMonStatus === LEADMON_TRANSACTION_STATUS.BOUGHT) {
                leadMonDetailsPromise =  getLeadMonDetails(inspectionToken);
            }
            if (isAuctionRunning(priceDiscovery)) {
                similarCarSoldPromise = getSimilarCarCount(inspectionToken);
            }

            // changing AUCTION_TYPE.includes(auctionType) to AUCTION_TYPE[auctionType] as its an object not array
            if (customerAuctionCount > NUMBER.ZERO && !(customerOcb || AUCTION_TYPE[auctionType])) {
                impressionCountPromise = getImpressionsCount(inspectionToken).catch(() => ({}));
            }

            const [
                challanData,
                doctet,
                pickupDetail,
                repeatUserDetails,
                selfNegoDetails,
                priceBreakup,
                selfNegoKycDetails,
                helperVideos,
                impressionCount,
                selfNegoVideos,
                leadMonDetails,
                similarCarSold,
                carHealth
            ] = await Promise.all([
                challanDataPromise,
                doctetPromise,
                pickupDetailPromise,
                repeatUserDetailsPromise,
                selfNegoDetailsPromise,
                priceBreakupPromise,
                selfNegoKycDetailsPromise,
                helperVideosPromise,
                impressionCountPromise,
                selfNegoVideoPromise,
                leadMonDetailsPromise,
                similarCarSoldPromise,
                carHealthPromise
            ]);

            const updatedPriceDiscovery = getUpdatedPriceDiscovery({priceDiscovery, isExpired, customerOcb, auctionType});
            const challanDetails = parseChallanDetails(challanData);
            const { type: deviceType = "Mobile"} = getDeviceType() || {};
            const isMobile = deviceType === "Mobile";
            const isGsAssuredPrice = auctionType === GS_AUCTION && assuredPriceFlag;
            const defaultTab = getCurrentTab({purchaseRequestStatus, isDeliveryApproved});
            const continueLoading = [NUMBER.THREE, NUMBER.TWO].includes(defaultTab);
            const { transactViaCars24Intent } = leadMonDetails || {};
            const { count: similarCarSoldCount } = similarCarSold || {};
            const { auctionId, impressionData, totalCount: count } = impressionCount || {};

            resolve({
                auctionResponse,
                ...(!isDeliveryApproved && {
                    priceBreakup: {
                        ...getParsedPriceBreakup({priceBreakup, showServiceCharge, challanDetails, offeredPrice})
                    }
                }),
                doctet,
                pickupDetail,
                isNoBid,
                inspectionResponse: {
                    ...inspectionResponse,
                    repeatUserDetails,
                    paiState,
                    priceDiscovery: updatedPriceDiscovery,
                    pll: {
                        ...(pll || {}),
                        ...(captureIntentAgain && { intent: "" })
                    },
                    isResetAuctionFlowActive: isResetAuction,
                    isDocbFlowActive: isDirectOcb && !isObjectEmpty(selfNegoDetails),
                    isSelfNegoFlowActive: isSelfNegotiation && !isObjectEmpty(selfNegoDetails),
                    isGSFlowActive: isGSOCB && !isObjectEmpty(selfNegoDetails),
                    isGsAssuredPrice,
                    impressionsCount: String(count ? count  : 0),
                    defaultTab,
                    impressionData,
                    auctionId
                },
                selfNegoDetails,
                selfNegoKycDetails,
                isMobile,
                helperVideos,
                selfNegoVideos,
                continueLoading: showLoaderScreen || continueLoading,
                leadMonDetail: {
                    isLeadMonActive: leadMon,
                    leadMonStatus,
                    leadMonTransactionStatus: transactViaCars24Intent,
                    ...leadMonDetails
                },
                similarCarSoldCount,
                carHealth,
                offlineDetails
            });
        } catch (e) {
            reject(e);
        }
    });
};

export {
    getCombinedDiyDetails,
    getOrderDetails,
    fetchSellerPackageData
};
